import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';

interface DeleteTemplateParams {
  templateId: string;
}

const deleteTemplate = async ({ templateId }: DeleteTemplateParams): Promise<void> => {
  return authFetch('/Adviser/PersonalFinanceTemplates/DeleteTemplate', {
    method: 'DELETE',
    ...httpBodyOptions({ templateId }),
  });
};

export const useDeleteTemplateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteTemplate, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.personalFinanceTemplates());
    },
  });
};
